import * as React from 'react';

import './AlertCustom.scss';
import infoIcon from 'src/assets/infoAlertIcon';
import warningIcon from 'src/assets/warningAlertIcon';
import i18n from 'src/translation/i18n';

export default function AlertCustom(props: IAlertCustomProps) {
  switch (props.type) {
    default:
    case 'error':
      return (
        <div className={`alert-error ${props.styleClass}`}>
          <div className="alert-message">
            <i className={`${props.icon} alert-error-icon`} />
            <pre className="alert-label">{props.message}</pre>
          </div>
          <div className="alert-extra-area">
            {props.children}
            <i
              className="rpds-close alert-close-button"
              onClick={props.handleCloseAlert}
            />
          </div>
        </div>
      );
      break;
    case 'success':
      return (
        <div className={`alert-success ${props.styleClass}`}>
          <div className="alert-message">
            <i className={`${props.icon} alert-success-icon`} />
            <label className="alert-label">{props.message}</label>
          </div>

          <div className="alert-extra-area">
            {props.children}
            {props.hasRouteHandler && (
              <div onClick={props.goToTab} className="alert-extra-area-link">
                {props.linkText}
              </div>
            )}
            {props.hasLink && (
              <div className="alert-extra-area-link">
                <a href={props.linkRoute}>{props.linkText}</a>
              </div>
            )}
            <i
              className="rpds-close alert-close-button"
              onClick={props.handleCloseAlert}
            />
          </div>
        </div>
      );
      break;
    case 'info':
      return (
        <div className={`alert-info ${props.styleClass}`}>
          <div className="alert-message">
            <i className={`${props.icon} alert-info-icon`} />
            {/* <img src={infoIcon} alt="" className="rp-alert-info-icon" /> */}
            <label className="alert-label">{props.message}</label>
          </div>

          <div className="alert-extra-area">
            {props.children}
            <span><div className="alert-btn-link" onClick={() => props.removeItemFromReturn(props.id)}><p className="alert-btn-link-text">{i18n.t('myReturns.removeFromReturnCart')}</p></div>  </span>
            | <span><div className="alert-btn-link" onClick={props.handleCloseAlert}><p className="alert-btn-link-text">{i18n.t('myReturns.returnAnyWay')}</p></div>  </span>
          </div>
         
        </div>
      );
      break;
    case 'warning':
      return (
        <div className={`alert-warning ${props.styleClass}`}>
          <div className="alert-message">
            <i className={`${props.icon} alert-warning-icon`} />
            {/* <img src={infoIcon} alt="" className="rp-alert-info-icon" /> */}
            <label className="alert-label">{props.message}</label>
          </div>

          <div className="alert-extra-area">
            {props.children}
            <i
              className="rpds-close alert-close-button"
              onClick={props.handleCloseAlert}
            />
          </div>
        </div>
      );
      break;
    case 'lwarning':
      return (
        <div className={`alert-warning ${props.styleClass}`}>
          <div className="alert-message">
            <i className={`${props.icon} alert-warning-icon`} />
            {/* <img src={infoIcon} alt="" className="rp-alert-info-icon" /> */}
            <label className="alert-label" style={{ textAlign: 'left' }}>
              {props.message}
            </label>
          </div>

          <div className="alert-extra-area">
            {props.children}
            <span><div className="alert-btn-link" onClick={() => props.removeAllPartsFromCart(props.id)}><p className="alert-btn-link-text">{i18n.t('myReturns.removeAllPartFromReturnCart')}</p></div>  </span>
            | <span><div className="alert-btn-link" onClick={props.handleTableCloseAlert}><p className="alert-btn-link-text">{i18n.t('myReturns.returnAnyWay')}</p></div>  </span>
          </div>
        </div>
      );
      break;
  }
}

interface IAlertCustomProps {
  type?: string;
  children?: any;
  styleClass?: string;
  message: string | any;
  icon: string;
  hasLink?: boolean;
  hasRouteHandler?: boolean;
  linkText?: string;
  goToTab?(): void;
  linkRoute?: string;
  handleCloseAlert(): void;
  removeItemFromReturn: (id: number) => void;
  id:number;
  handleTableCloseAlert(): void;
  removeAllPartsFromCart: (id: number) => void;
}
